<ng-template #modalButton let-text="text">
  <fcom-button
    class="close-modal-btn"
    [text]="text | finLocalization"
    [disabled]="!open() || forceRemainOpen()"
    (clickBtn)="onClose()"
    data-testid="modal-close-btn"
  />
</ng-template>

<ng-template #buttonTmpl>
  <div class="align-right pr-medium-x pr-xsmall-y nordic-blue-25-bg rounded-bottom-large">
    @switch (buttons()) {
      @case (ModalButtons.CLOSE) {
        <ng-container [ngTemplateOutlet]="modalButton" [ngTemplateOutletContext]="{ text: 'actions.close' }" />
      }
      @case (ModalButtons.OK) {
        <ng-container [ngTemplateOutlet]="modalButton" [ngTemplateOutletContext]="{ text: 'actions.ok' }" />
      }
      @case (ModalButtons.CONTINUE_CANCEL) {
        <ng-container [ngTemplateOutlet]="modalButtonContinueCancel" />
      }
      @case (ModalButtons.CUSTOM) {
        <ng-content select="[buttons]" />
      }
      @default {
        <ng-container [ngTemplateOutlet]="modalButton" [ngTemplateOutletContext]="{ text: 'actions.done' }" />
      }
    }
  </div>
</ng-template>

<ng-template #modalButtonContinueCancel>
  <fcom-button
    class="close-modal-btn mr-small-r"
    [text]="cancelTranslationKey() | finLocalization"
    [disabled]="!open() || forceRemainOpen() || loading()"
    [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
    (clickBtn)="onClose()"
  />
  <fcom-button
    class="confirm-modal-btn"
    [text]="confirmTranslationKey() | finLocalization"
    [disabled]="!open() || !confirmEnabled() || forceRemainOpen()"
    [loading]="loading()"
    [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
    (clickBtn)="onConfirm()"
  />
</ng-template>

<ng-template #modalContent>
  <div
    #modalOverlay
    data-testid="modal-overlay"
    class="modal"
    [ngClass]="{ 'fit-content-mobile': !fullHeightMobile(), 'ps-xsmall-t': shouldAddPaddingTop() }"
    [attr.aria-labelledby]="'modal-' + modalId + '-title'"
    role="dialog"
    aria-modal="true"
    (click)="overlayClick($event)"
  >
    <div
      data-testid="modal-content"
      class="modal-wrapper grow flex flex--column white-bg rounded-large"
      [ngClass]="{
        'fit-to-content': fitToContent(),
        'full-height': fullHeight(),
        'extra-wide': extraWide(),
      }"
    >
      <header class="modal-header fill relative flex--column border-bottom" [class.is-hidden]="!title()">
        <div class="flex--nogrow flex--basis-header flex flex--row flex--center pr-medium-l">
          @if (title()) {
            <h2
              #modalHeading
              class="font-heading-4 flex-1 truncate overflow-hidden nordic-blue-900-text"
              [ngClass]="titleClasses()"
              [attr.id]="'modal-' + modalId + '-title'"
              data-testid="modal-title"
              tabindex="-1"
            >
              {{ title() }}
            </h2>
          }
          @if (!forceRemainOpen() && (modalService.hideCloseButton$ | async) === false) {
            <fcom-icon-button
              #closeButton
              class="close-button flex--nogrow focus-inset pr-medium-r flex--self-center"
              [icon]="{ name: SvgLibraryIcon.CLOSE_DELETE }"
              [aria]="{ label: 'actions.close' | finLocalization }"
              [theme]="IconButtonTheme.LIGHT_TERTIARY_GHOST"
              [disabled]="!open()"
              [title]="'actions.close' | finLocalization"
              (clickBtn)="onClose()"
            />
          }
        </div>
        <ng-content select="[subtitle]" />
      </header>
      <div
        class="modal-content-wrapper flex-1 scroll relative"
        [class.rounded-large]="roundedContent()"
        tabindex="0"
        #content
      >
        <ng-content />
      </div>
      @if (buttons()) {
        <footer class="flex--nogrow">
          <div class="message-box-wrapper ps-medium-x ps-medium-b"><ng-content select="[messageBox]" /></div>
          <ng-container *ngTemplateOutlet="buttonTmpl" />
        </footer>
      }
    </div>
  </div>
</ng-template>

@if (open()) {
  <div
    fcomTrapFocus
    class="transition"
    (keydown.escape)="onCloseEvent($event)"
    animate.enter="open-animation"
    animate.leave="close-animation"
  >
    <ng-container *ngTemplateOutlet="modalContent" />
  </div>
}
